var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 46,
    viewBox: "0 0 33 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.43629 24.4422C4.86382 32.119 9.66687 39.1412 14.7807 45.3504C15.1208 45.7634 15.6106 46 16.1251 46C16.6397 46 17.1294 45.7633 17.4695 45.3502C22.5826 39.1405 27.3854 32.119 30.8135 24.4426C31.7687 22.3028 32.25 19.9905 32.25 17.5842C32.2491 8.27863 24.907 0 16.1244 0C7.34189 0 0 8.27876 0 17.5841C0 19.9897 0.481437 22.3021 1.43629 24.4422Z",
    fill: "#E50010"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0625 9C11.7518 9 11.5 9.25184 11.5 9.5625V12.375H9.8125C9.62443 12.375 9.4488 12.469 9.34447 12.6255L7.09447 16.0005C6.9794 16.1731 6.96867 16.395 7.06656 16.5779C7.16444 16.7608 7.35505 16.875 7.5625 16.875H8.125V26.4375C8.125 26.7482 8.37684 27 8.6875 27H23.3125C23.6232 27 23.875 26.7482 23.875 26.4375V16.875H24.4375C24.6449 16.875 24.8356 16.7608 24.9334 16.5779C25.0313 16.395 25.0206 16.1731 24.9055 16.0005L22.6555 12.6255C22.5512 12.469 22.3756 12.375 22.1875 12.375H20.5V9.5625C20.5 9.25184 20.2482 9 19.9375 9H12.0625ZM19.375 12.375V10.125H12.625V12.375H19.375ZM10.1135 13.5L8.61354 15.75H23.3865L21.8865 13.5H19.375V15.1875H18.25V13.5H13.75V15.1875H12.625V13.5H10.1135ZM9.25 16.875H22.75V25.875H21.625V18.5625C21.625 18.2518 21.3732 18 21.0625 18H10.9375C10.6268 18 10.375 18.2518 10.375 18.5625V25.875H9.25V16.875ZM15.4375 25.875V19.125H11.5V25.875H15.4375ZM16.5625 19.125V25.875H20.5V19.125H16.5625Z",
    fill: "#F3F3F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationActive);
export default __webpack_public_path__ + "static/media/LocationActive.048fd64976055ffef74ffcf2c313c8a1.svg";
export { ForwardRef as ReactComponent };